var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:`font--button rounded-pill px-4 full-width ${
    _vm.textColor ? _vm.textColor + '--text' : ''
  }`,attrs:{"depressed":"","color":_vm.color,"x-small":_vm.size === 'x-small',"small":_vm.size === 'small',"large":_vm.size === 'large',"x-large":_vm.size === 'x-large'},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }